// extracted by mini-css-extract-plugin
module.exports = {"face":"usersDataTable_face__kyqnT","table":"usersDataTable_table__19gpK","wrapContent":"usersDataTable_wrapContent__3eX0c","fitContent":"usersDataTable_fitContent__wJBMU"};